import { render, staticRenderFns } from "./origination-metrics.vue?vue&type=template&id=101d7346&scoped=true&"
import script from "./origination-metrics.vue?vue&type=script&lang=js&"
export * from "./origination-metrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101d7346",
  null
  
)

export default component.exports